<template>
  <div class="row">
    <div class="input-field col s12">
      <input id="phone" type="tel" v-model="phone" autocomplete="off">
      <label for="phone" v-bind:class="{ active: phone }">Numéro de téléphone</label>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    phone: {
      get() {
        return this.$store.state.phone;
      },
      set(value) {
        this.$store.commit("updatePhone", value);
      }
    }
  }
};
</script>